import React, { memo } from 'react';
import { get } from 'lodash-es';
import { useSelector } from 'react-redux';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { LEASE_DEALS_FILTERS } from 'site-modules/lease-deals/constants/lease-deals-constants';
import {
  FILTERS_LAYOUT_DESKTOP,
  FILTERS_LAYOUT_MOBILE,
} from 'site-modules/lease-deals/components/filters/infrastructure/filters-config';
import { FiltersModal } from 'site-modules/lease-deals/components/filters/shell/filters-modal/filters-modal';
import { FiltersDrawer } from 'site-modules/lease-deals/components/filters/shell/filters-drawer/filters-drawer';
import { FilterLayout } from 'site-modules/lease-deals/components/filters/shell/filter-layout/filter-layout';
import { FiltersButton } from 'site-modules/lease-deals/components/filters/ui/filters-button/filters-button';
import { FiltersDataProvider } from 'site-modules/lease-deals/components/filters/infrastructure/filters-data-provider/filters-data-provider';
import { FilterGroupContainer } from 'site-modules/lease-deals/components/filters/infrastructure/filter-group-container/filter-group-container';

export const LeaseDealsFilters = memo(() => {
  const [isOpen, toggle] = useToggle(false);
  const isMobile = useSelector(state => get(state, 'mobile'));

  const filterConfigs = isMobile ? FILTERS_LAYOUT_MOBILE : FILTERS_LAYOUT_DESKTOP;

  const ViewComponent = isMobile ? FiltersDrawer : FiltersModal;

  return (
    <>
      <FiltersButton onClick={toggle} />
      <ViewComponent isOpen={isOpen} toggle={toggle} dataTrackingParent={LEASE_DEALS_FILTERS}>
        <FilterLayout toggle={toggle}>
          <FiltersDataProvider>
            {(filtersData, onFilterUpdate) => {
              if (!filtersData) return null;
              return (
                <>
                  {filterConfigs.map(groupConfig => (
                    <FilterGroupContainer
                      key={groupConfig.groupId}
                      groupConfig={groupConfig}
                      filtersData={filtersData}
                      onFilterUpdate={onFilterUpdate}
                    />
                  ))}
                </>
              );
            }}
          </FiltersDataProvider>
        </FilterLayout>
      </ViewComponent>
    </>
  );
});

LeaseDealsFilters.displayName = 'LeaseDealsFilters';
